import { useEffect, useLayoutEffect } from "react";
import { applyViewportScaleOsClass } from "utils/viewportScaleOs";

const MIN_WIDTH_PX = 1025;

export function useViewportHostSizeVars(): void {
  useLayoutEffect(() => {
    if (typeof document === "undefined") return;
    applyViewportScaleOsClass();
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    const root = document.documentElement;
    const mq = window.matchMedia(`(min-width: ${MIN_WIDTH_PX}px)`);

    const setVars = () => {
      if (!mq.matches) {
        root.style.removeProperty("--viewport-host-px-w");
        root.style.removeProperty("--viewport-host-px-h");
        return;
      }
      const w = root.clientWidth;
      const vv = window.visualViewport;
      const h =
        vv && typeof vv.height === "number" && vv.height > 0 ? vv.height : window.innerHeight;
      root.style.setProperty("--viewport-host-px-w", `${w}px`);
      root.style.setProperty("--viewport-host-px-h", `${h}px`);
    };

    setVars();
    mq.addEventListener("change", setVars);
    window.addEventListener("resize", setVars);
    window.visualViewport?.addEventListener("resize", setVars);
    window.visualViewport?.addEventListener("scroll", setVars);

    return () => {
      mq.removeEventListener("change", setVars);
      window.removeEventListener("resize", setVars);
      window.visualViewport?.removeEventListener("resize", setVars);
      window.visualViewport?.removeEventListener("scroll", setVars);
      root.style.removeProperty("--viewport-host-px-w");
      root.style.removeProperty("--viewport-host-px-h");
    };
  }, []);
}
